import { render, staticRenderFns } from "./bGalleryView.vue?vue&type=template&id=68f0d2aa&scoped=true"
import script from "./bGalleryView.vue?vue&type=script&lang=js"
export * from "./bGalleryView.vue?vue&type=script&lang=js"
import style0 from "./bGalleryView.vue?vue&type=style&index=0&id=68f0d2aa&prod&scoped=true&lang=css"
import style1 from "./bGalleryView.vue?vue&type=style&index=1&id=68f0d2aa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68f0d2aa",
  null
  
)

export default component.exports